import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    overflow-x: hidden; //prevent menu from forming horizontal side bar
    font-family: 'Inter', sans-serif;
    background-color: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
  }


//For lenis
html.lenis, html.lenis body {
  height: auto;
}

.lenis.lenis-smooth {
  scroll-behavior: auto !important;
}

.lenis.lenis-smooth [data-lenis-prevent] {
  overscroll-behavior: contain;
}

.lenis.lenis-stopped {
  overflow: hidden;
}

.lenis.lenis-smooth iframe {
  pointer-events: none;
}


//The following is applied to the Animated text
.heavyText{
  font-size: 25px;
  @media (max-width: 768px) {
      font-size: 18px;
    }
    @media (max-width: 576px) {
      text-align: start;
    }
    text-align: center;
}
.lightText{
  font-size: 22px;
  font-weight: 300;
  max-width: 400px;

  @media (max-width: 768px) {
    font-size: 17px;
}

`;
